import {Timestamp} from 'firebase/firestore';
import moment from 'moment';
import {TranslatedLanguage} from 'hubbl-shared';
import {getI18n} from '../../../i18n';

export const formatEventDate = (
  date: Timestamp,
  language?: TranslatedLanguage,
) => {
  const t = getI18n(language);
  const eventDate = date.toDate();
  const now = new Date();
  const diffDays = moment(eventDate)
    .startOf('day')
    .diff(moment(now).startOf('day'), 'days');

  if (diffDays === 0) return t.common.today;
  if (diffDays === 1) return t.common.tomorrow;
  if (diffDays < 7) {
    // Use moment with locale for day names
    const momentDate = moment(eventDate);
    if (language === 'da') {
      momentDate.locale('da');
    }
    const dayName = momentDate.format('dddd');
    // Capitalize first letter
    return dayName.charAt(0).toUpperCase() + dayName.slice(1);
  }
  return moment(eventDate).format('MMM D, YYYY');
};

export const formatEventTime = (
  date: Timestamp,
  language?: TranslatedLanguage,
) => {
  const locale = language === 'da' ? 'da-DK' : 'en-US';
  return date.toDate().toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
  });
};
